import { useMutation } from "@tanstack/react-query";
import { requestPlaylistRecommendations } from "../../api/playlist";
import { toPlaylistRecommendation } from "../../domain/recommendations";
import { PlaylistRecommendationResult } from "../../domain/recommendations";

type MutationInput = {
  playlistRef: string;
  turnstileToken?: string;
};

export const usePlaylistRecommendations = () =>
  useMutation<PlaylistRecommendationResult, Error, MutationInput>({
    mutationFn: async (payload) => {
      const response = await requestPlaylistRecommendations(payload);
      return toPlaylistRecommendation({ data: response });
    }
  });

